import {
  EXPORT_ADMIN_BULK_EDIT_JOBS,
  EXPORT_ADMIN_BULK_EDIT_JOBS_ERROR,
  EXPORT_ADMIN_BULK_EDIT_JOBS_SUCCESS,
  GET_ADMIN_BULK_EDIT_JOBS,
  GET_ADMIN_BULK_EDIT_JOBS_ERROR,
  GET_ADMIN_BULK_EDIT_JOBS_SUCCESS,
} from "./actionTypes"

export const getAdminBulkEditJobs = (payload) => {
  return {
    type: GET_ADMIN_BULK_EDIT_JOBS,
    payload: payload
  }
}

export const getAdminBulkEditJobsSuccess = (response) => {
  return {
    type: GET_ADMIN_BULK_EDIT_JOBS_SUCCESS,
    payload: response,
  }
}

export const getAdminBulkEditJobsError = error => {
  return {
    type: GET_ADMIN_BULK_EDIT_JOBS_ERROR,
    payload: error,
  }
}

export const exportAdminBulkEditJobs = (payload) => {
  return {
    type: EXPORT_ADMIN_BULK_EDIT_JOBS,
    payload: payload
  }
}

export const exportAdminBulkEditJobsSuccess = () => {
  return {
    type: EXPORT_ADMIN_BULK_EDIT_JOBS_SUCCESS,
  }
}

export const exportAdminBulkEditJobsError = error => {
  return {
    type: EXPORT_ADMIN_BULK_EDIT_JOBS_ERROR,
    payload: error,
  }
}
